export default {
  current: {
    title: 'Thanks for being a Tradier Brokerage Customer!',
    body: 'To start a new application, please log in to your account below.'
  },
  pending: {
    title: 'Want to pick up where you left off?',
    body: 'Please log in to start a new application or continue a previous application.'
  },
  submitted: {
    title: 'You\'re almost there!',
    body: 'Please log in to check the status of your submitted application.'
  }
}
